import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as authAction from "../Store/_redux/AuthStore/authActions";
import moment from "moment";

const initialSignupValues = {
  tc: "",
  name: "",
  surname: "",
  position: "",
  password: "",
  userType: "",
  startDate: "",
  birthDay: moment().format("YYYY-MM-DD"), 
};

export default function Signup() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState(initialSignupValues);
  const [tcError, setTcError] = useState("");

  const isValidTC = (tc) => {
    if (!/^[1-9][0-9]{10}$/.test(tc)) return false;

    const digits = tc.split("").map(Number);
    if (digits.length !== 11) return false;

    const sumOdd = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
    const sumEven = digits[1] + digits[3] + digits[5] + digits[7];

    const check1 = (sumOdd * 7 - sumEven) % 10;
    const check2 = digits.slice(0, 10).reduce((acc, val) => acc + val, 0) % 10;

    return check1 === digits[9] && check2 === digits[10];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "tc") {
      const onlyDigits = value.replace(/\D/g, ""); // sadece rakamları al
      setForm((prev) => ({ ...prev, tc: onlyDigits, userType: "user" }));

      if (onlyDigits.length === 11) {
        if (!isValidTC(onlyDigits)) {
          setTcError("Lütfen geçerli bir T.C. Kimlik numarası giriniz");
        } else {
          setTcError("");
        }
      } else {
        setTcError("");
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value, userType: "user" }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    
    dispatch(authAction.userRegister(form)).then((res) => {
      if (res) {
        alert("Kullanıcı kaydedildi");
        navigate("/");
      } else {
        alert("Hatalı kayıt");
      }
    });
  };

  return (
    <form
      onSubmit={onSubmit}
      className="flex flex-col justify-center w-[600px] mx-auto py-[30px]"
    >
      <h1 className="font-semibold text-2xl py-5">Kullanıcı Kayıt</h1>
      <div className="grid grid-cols-2 gap-x-3">
        <div className="flex flex-col">
          <label htmlFor="signup-name" className="font-semibold py-2">İsim</label>
          <input
            id="signup-name"
            name="name"
            autoComplete="given-name"
            value={form.name}
            onChange={handleChange}
            placeholder="Ad"
            className="border-[1px] rounded-md px-3 py-2 border-input-b"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="signup-surname" className="font-semibold py-2">Soyisim</label>
          <input
            id="signup-surname"
            name="surname"
            autoComplete="family-name"
            value={form.surname}
            onChange={handleChange}
            placeholder="Soyad"
            className="border-[1px] rounded-md px-3 py-2 border-input-b"
          />
        </div>
      </div>

      <label htmlFor="signup-tc" className="font-semibold py-2">TC Kimlik</label>
      <input
        id="signup-tc"
        name="tc"
        autoComplete="username"
        value={form.tc}
        onChange={handleChange}
        placeholder="TC kimlik numarası"
        className="border-[1px] rounded-md px-3 py-2 border-input-b w-full"
      />
      {tcError && <p className="text-red-500 text-sm">{tcError}</p>}

      <label className="font-semibold py-2">Çalışma Yeri Görevi</label>
      <div className="grid grid-cols-2 gap-x-3 mb-2">
        {["Arge Personeli", "Stajyer"].map((position) => (
          <div
            key={position}
            className={`flex px-3 gap-x-2 py-2 border-[1px] rounded-md cursor-pointer ${
              form.position === position
                ? "bg-select-bg border-select-b"
                : "bg-input-bg border-transparent"
            }`}
          >
            <input
              type="radio"
              id={`position-${position}`}
              name="position"
              value={position}
              checked={form.position === position}
              onChange={handleChange}
            />
            <label htmlFor={`position-${position}`} className="cursor-pointer">{position}</label>
          </div>
        ))}
      </div>
      <label htmlFor="signup-start-date" className="font-semibold py-2">İşe Başlama Tarihi </label>
      <input
        id="signup-start-date"
        value={form.startDate}
        onChange={handleChange}
        name="startDate"
        type="date"
        className="border-[1px] rounded-md px-3 py-2 border-input-b"
        required
      />
       <label htmlFor="signup-birthday" className="font-semibold py-2">Doğum Tarihi</label>
      <input
        id="signup-birthday"
        value={form.birthDay}
        onChange={handleChange}
        name="birthDay"
        type="date"
        className="border-[1px] rounded-md px-3 py-2 border-input-b"
        required
      />
      <label htmlFor="signup-password" className="font-semibold py-2">Şifre</label>
      <input
        id="signup-password"
        name="password"
        type="password"
        autoComplete="new-password"
        value={form.password}
        onChange={handleChange}
        placeholder="Şifre"
        className="border-[1px] rounded-md px-3 py-2 border-input-b w-full"
      />

      <div className="flex justify-end my-4">
        <button
          type="submit"
          className="bg-select-b px-6 py-3 rounded-md text-white"
        >
          Kayıt Et
        </button>
      </div>
    </form>
  );
}
